import * as Yup from "yup";
import { endpointsMd } from "utils/metadata-split/constant";

export type createStateLanguagePreType = {
  state_id: string;
  board_id: string;
  segment_id: string;
  class_id: string;
};

export const createStateLanguagePreInitialValues: createStateLanguagePreType = {
  state_id: "",
  board_id: "",
  segment_id: "",
  class_id: "",
};

export const createStateLanguagePreMandatoryFields = [
  { id: "state_id" },
  { id: "board_id" },
  { id: "segment_id" },
  { id: "class_id" },
];

export const createStateLanguagePreValidationSchema = Yup.object().shape({
  state_id: Yup.string().required("state_id is required"),
  board_id: Yup.string().required("board_id is required"),
  segment_id: Yup.string().required("segment_id is required"),
  class_id: Yup.string().required("class_id is required"),
});

export const createStateLanguageProperties = [
  {
    id: "state_id",
    type: "single-select-dependency",
    label: "State *",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    options: [],
    list: "state_list",
    keyValue: { label: "state_name", value: "state_id" },
    required: true,
  },
  {
    id: "board_id",
    type: "single-select-dependency",
    label: "Board*",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    options: [],
    list: "board_list",
    required: true,
    keyValue: { label: "board_name", value: "board_id" },
  },
  {
    id: "segment_id",
    type: "normal-select",
    label: "Segment *",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    options: [],
    list: "segment_list",
    onlyApiCall: true,
    requestList: async (payload) => {
      return {};
    },
    endpoint: endpointsMd.SEGMENT_LIST,
    keyValue: { label: "segment_name", value: "segment_id" },
  },
  {
    id: "class_id",
    type: "single-select-dependency",
    label: "Class *",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    options: [],
    required: true,
    list: "class_course_batch_data",
    keyValue: { label: "class_name", value: "class_id" },
  },
];

export type createStateLanguageSecPreType = {
  first_language_list: string[];
  second_language_list: string[];
  third_language_list: string[];
};

export const createStateLanguageSecPreInitialValues: createStateLanguageSecPreType =
  {
    first_language_list: [],
    second_language_list: [],
    third_language_list: [],
  };

export const createStateLanguageSecPreMandatoryFields = [
  { id: "first_language_list" },
  { id: "second_language_list" },
  { id: "third_language_list" },
];

export const createStateLanguageSecPreValidationSchema = Yup.object().shape({
   first_language_list: Yup.array()
    .min(1, "first_language_list value required")
    .required("value required"),
  second_language_list: Yup.array()
    .min(1, "second_language_list value required")
    .required("value required"),
  third_language_list: Yup.array()
    .min(1, "third_language_list value required")
    .required("value required"),
});

export const createStateLanguageSecProperties = [
  {
    id: "first_language_list",
    type: "multi-select",
    label: "First Language List *",
    className: "select-styles",
    required: true,
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    options: [],
    list: "generic_language_list",
    keyValue: { label: "generic_name", value: "generic_name" },
  },
  {
    id: "second_language_list",
    type: "multi-select",
    label: "Second Language List *",
    className: "select-styles",
    required: true,
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    options: [],
    list: "generic_language_list",
    keyValue: { label: "generic_name", value: "generic_name" },
  },
  {
    id: "third_language_list",
    type: "multi-select",
    label: "Third Language List *",
    className: "select-styles",
    required: true,
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    options: [],
    list: "generic_language_list",
    keyValue: { label: "generic_name", value: "generic_name" },
  },
];

// update page
export type updateStateLanguagePreType = {
  state_id: string;
  board_id: string;
  segment_id: string;
  class_id: string;
  first_language_list: string[];
  second_language_list: string[];
  third_language_list: string[];
};

export const updateStateLanguagePreInitialValues: updateStateLanguagePreType = {
  state_id: "",
  board_id: "",
  segment_id: "",
  class_id: "",
  first_language_list: [],
  second_language_list: [],
  third_language_list: [],
};

export const updateStateLanguagePreMandatoryFields = [
  { id: "state_id" },
  { id: "board_id" },
  { id: "segment_id" },
  { id: "class_id" },
  { id: "first_language_list" },
  { id: "second_language_list" },
  { id: "third_language_list" },
];

export const updateStateLanguagePreValidationSchema = Yup.object().shape({
  state_id: Yup.string().required("state_id is required"),
  board_id: Yup.string().required("board_id is required"),
  segment_id: Yup.string().required("segment_id is required"),
  class_id: Yup.string().required("class_id is required"),
  first_language_list: Yup.array()
    .min(1, "first_language_list value required")
    .required("value required"),
  second_language_list: Yup.array()
    .min(1, "second_language_list value required")
    .required("value required"),
  third_language_list: Yup.array()
    .min(1, "third_language_list value required")
    .required("value required"),
});


export const updateStateLanguageProperties = [
  {
    id: "state_id",
    type: "single-select-dependency",
    label: "State *",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    options: [],
    list: "state_list",
    keyValue: { label: "state_name", value: "state_id" },
    required: true,
  },
  {
    id: "board_id",
    type: "single-select-dependency",
    label: "Board*",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    options: [],
    list: "board_list",
    required: true,
    keyValue: { label: "board_name", value: "board_id" },
  },
  {
    id: "segment_id",
    type: "normal-select",
    label: "Segment *",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    options: [],
    list: "segment_list",
    onlyApiCall: true,
    requestList: async (payload) => {
      return {};
    },
    endpoint: endpointsMd.SEGMENT_LIST,
    keyValue: { label: "segment_name", value: "segment_id" },
  },
  {
    id: "class_id",
    type: "single-select-dependency",
    label: "Class *",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    options: [],
    required: true,
    list: "class_course_batch_data",
    keyValue: { label: "class_name", value: "class_id" },
  },
   {
    id: "first_language_list",
    type: "multi-select",
    label: "First Language List *",
    className: "select-styles",
    required: true,
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    options: [],
    list: "generic_language_list",
    keyValue: { label: "generic_name", value: "generic_name" },
  },
  {
    id: "second_language_list",
    type: "multi-select",
    label: "Second Language List *",
    className: "select-styles",
    required: true,
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    options: [],
    list: "generic_language_list",
    keyValue: { label: "generic_name", value: "generic_name" },
  },
  {
    id: "third_language_list",
    type: "multi-select",
    label: "Third Language List *",
    className: "select-styles",
    required: true,
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    options: [],
    list: "generic_language_list",
    keyValue: { label: "generic_name", value: "generic_name" },
  },
];


export function areAllFieldsFilled(allObjects) {

  return allObjects.every(obj =>
    Object.values(obj).every(value =>
      value !== null &&
      value !== undefined &&
      value !== '' &&
      (!Array.isArray(value) || value.length > 0)
    )
  );
}
